<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left">Build details</h5>
    </div>
    <div class=" w-100 float-left mt-3">
        <div class="col-lg-3 col-md-3 col-sm-3 col-3 float-left"><h6>Build number UI:</h6></div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-3 float-left"><h6>{{buildNumber}}</h6></div>
    </div>
    <div class="w-100 float-left mt-3">
        <div class="col-lg-3 col-md-3 col-sm-3 col-3 float-left"><h6>Build number Backend:</h6></div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-3 float-left"><h6>{{backEndbuildNumber}}</h6></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/superAdmin/buildDetailsComponent.html